<template>
  <!-- <section style="background:url(/images/bg1.jpg); background-attachment: fixed;"> -->
  <!-- <div style="background-color:rgba(0, 0, 0, 0.7);"> -->
  <v-container grid-list-xl>
    <v-layout align-center justify-center row wrap my-2>
      <v-flex xs12 sm12 md12>
        <h1 style="text-align:center; font-size:25px; line-height:1.2em; margin-bottom:-30px;">
          <span style="font-size:35px;">Assista ao vídeo</span>
          <br>institucional da escola
          <br>
          <img src="/images/logo-nome-simples.svg" style="height:70px;">
        </h1>
        <br>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <div class="videoWrapper">
          <iframe
            src="https://www.youtube.com/embed/V-GSOfgyvsY"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md6 >
        <h1 style="text-align:center; font-size:25px; line-height:1.2em; margin-bottom:10px">
          <span style="font-size:35px;">Já conhece nossos</span>
          <br>diferencias?
        </h1>

        <div class="videoWrapper">
          <iframe
            src="https://www.youtube.com/embed/Quey6PHgePw"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md6 >
        <h1 style="text-align:center; font-size:25px; line-height:1.2em; margin-bottom:10px">
          <span style="font-size:35px;">Nossa</span>
          <br>Educação Infantil
        </h1>

        <div class="videoWrapper">
          <iframe
            src="https://www.youtube.com/embed/Wo4GcEkCHGI"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md6 >
        <h1 style="text-align:center; font-size:25px; line-height:1.2em; margin-bottom:10px">
          <span style="font-size:35px;">Escola Engenho</span>
          <br>Animação
        </h1>

        <div class="videoWrapper">
          <iframe
            src="https://www.youtube.com/embed/rADplVntDCE"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md6 >
        <h1 style="text-align:center; font-size:25px; line-height:1.2em; margin-bottom:10px">
          <span style="font-size:35px;">Nós somos</span>
          <br>Engenho!
        </h1>

        <div class="videoWrapper">
          <iframe
            src="https://www.youtube.com/embed/aPHF9SMqTVE"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md6 >
        <h1 style="text-align:center; font-size:25px; line-height:1.2em; margin-bottom:10px">
          <span style="font-size:35px;">Semana</span>
          <br>da Alimentação
        </h1>

        <div class="videoWrapper">
          <iframe
            src="https://www.youtube.com/embed/nOhWtWr7pMA"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- </div> -->
  <!-- </section> -->
</template>

<script>
export default {
  data: () => ({})
};
</script>

<style lang="scss" scoped>
p {
  text-align: center;
}
</style>
